import AmplitudeProvider from "./AmplitudeProvider";

export default AmplitudeProvider;
